
import WithColorMixin from '@/mixins/WithColorMixin.vue';
import { FilterValues } from '@/types/score';
import { PropType } from 'vue';
import { defineComponent } from 'vue';


const __default__ = defineComponent({
    name: 'ValueSlider',
    emits: ["discardMetric", "update:modelValue"],
    props: {
        label: {
            type: String
        },
        modelValue: {
            type: [Object, Number] as PropType<FilterValues>,
            default: () => {return {minValue: 0, maxValue: 1}}
        },
        width: {
            type: Number,
            default: 100
        },
        height: {
            type: Number,
            default: 15
        },
        active: {
            type: Boolean,
            default: false
        },
        range: {
            type: Boolean,
            default: false
        },
        hideDiscardButton: {
            type: Boolean,
            default: false
        },
        hideLabel: {
            type: Boolean,
            default: false
        }
    },
    mixins: [WithColorMixin],
    data () {
        return {
            minValue: 0,
            maxValue: 1,
            slidingLeft: false,
            slidingRight: false
        }
    },
    mounted () {
        if (typeof this.modelValue === "number") {
            this.minValue = 0
            this.maxValue = this.modelValue
        } else {
            this.minValue = Math.max(this.modelValue.minValue - 1, 0)
            this.maxValue = Math.max(this.modelValue.maxValue, 1)
        }
    },
    computed: {
        stepWidth (): number {
            return (this.width / 5)
        },
        sliderWidth (): string {
            return this.width + "px"
        },
        sliderHeight (): string {
            return this.height + "px"
        },
        backFillWidth (): string {
            return this.stepWidth * (this.minValue) + "px"
        },
        fillWidth (): string {
            return this.stepWidth * (this.maxValue - this.minValue) + "px"
        },
        thumbHeigth (): string {
            return this.height + 2 + "px"
        },
        thumbHoverColor (): string {
            return this.active ? "var(--cream)" : "var(--white)"
        },
        isSliding (): boolean {
            return this.slidingLeft || this.slidingRight
        },
        sliderPosition(): number {
            return (this.$refs["container"] as any).getBoundingClientRect().x
        }
    },
    methods: {
        startSliding (event: any) {
            const position = event.pageX
            if (this.range) {
                // If the cursor stands from the first half of the selected bar or left of the left thumb.
                if (position - (this.maxValue - this.minValue) / 2 * this.stepWidth < this.sliderPosition + this.minValue * this.stepWidth)
                    this.slidingLeft = this.active
                else 
                    this.slidingRight = this.active
            } else {
                this.slidingRight = this.active
            }
        },
        startSlidingRight () {
            this.slidingRight = this.active
        },
        startSlidingLeft () {
            this.slidingLeft = this.active && this.range
        },
        stopSliding (event: any) {
            if (this.active && this.slidingRight) {
                this.updateMaxValueFromPosition(event.pageX)
                this.slidingRight = false
            }
            if (this.active && this.slidingLeft) {
                this.updateMinValueFromPosition(event.pageX)
                this.slidingLeft = false
            }
        },
        slide (event: any) {
            if (this.active && this.slidingRight) {
                this.updateMaxValueFromPosition(event.pageX)
            }
            if (this.active && this.slidingLeft) {
                this.updateMinValueFromPosition(event.pageX)
            }
        },
        moveSlider (event: any) {
            const position = event.pageX

            if (this.active) {
                if (this.slidingLeft) {
                    this.updateMinValueFromPosition(position)
                    this.slidingLeft = false
                } else if (this.slidingRight) {
                    this.updateMaxValueFromPosition(position)
                    this.slidingRight = false
                }
            }
        },
        updateMaxValueFromPosition(position: number) {
            this.maxValue = Math.max(Math.floor((position - this.sliderPosition - this.stepWidth / 2) / this.stepWidth) + 1, this.minValue + 1)
            this.emit()
        },
        updateMinValueFromPosition(position: number) {
            this.minValue = Math.min(Math.floor((position - this.sliderPosition - this.stepWidth / 2) / this.stepWidth) + 1, this.maxValue - 1)
            this.emit()
        },
        emit () {
          this.$emit('update:modelValue', {minValue: this.minValue + 1, maxValue: this.maxValue})
        },
        discard ()  {
            this.$emit("discardMetric", this.label)
        }
    }
});


import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "63a9d190": (_ctx.sliderHeight),
  "4e5ebc3d": (_ctx.sliderWidth),
  "15b47a15": (_ctx.lightColor),
  "27e81b36": (_ctx.darkColor),
  "11fba498": (_ctx.backFillWidth),
  "1904aadb": (_ctx.fillWidth),
  "72b6ea46": (_ctx.thumbHeigth),
  "1b89fcd5": (_ctx.thumbHoverColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__